import React, { useState } from "react";
import styles from "./TreeNode.module.css";

const TreeNode = ({
  node,
  expanded,
  toggle,
  onDrop,
  onReorder,
  selectedId,
  setSelected,
  handleSelectItem,
  onDoubleClick,
  onFocusOut,
}) => {
  const [dropPosition, setDropPosition] = useState(null);

  const dragStart = (e) => {
    e.dataTransfer.setData("dragId", node.id);
    e.dataTransfer.setData("parentId", node.parentId);
    e.currentTarget.classList.add(styles.dragging);
  };

  const dragEnd = (e) => {
    e.currentTarget.classList.remove(styles.dragging);
    setDropPosition(null);
  };

  const dragOver = (e) => {
    e.preventDefault();

    const rect = e.currentTarget.getBoundingClientRect();
    const offsetY = e.clientY - rect.top;
    const height = rect.height;

    if (
      node.isDirectory &&
      offsetY > height * 0.33 &&
      offsetY < height * 0.66
    ) {
      setDropPosition("inside");
    } else if (offsetY <= height / 2) {
      setDropPosition("before");
    } else {
      setDropPosition("after");
    }
  };

  const dragLeave = () => setDropPosition(null);

  const drop = (e) => {
    e.preventDefault();

    const dragId = Number(e.dataTransfer.getData("dragId"));
    const sourceParentId = Number(e.dataTransfer.getData("parentId"));

    setDropPosition(null);
    if (dragId === node.id) return;

    if (dropPosition === "inside" && node.isDirectory) {
      onDrop(dragId, node.id);
    } else {
      onReorder(dragId, node.id, node.parentId, dropPosition);
    }
  };

  return (
    <div style={{ marginLeft: 20 }}>
      <div
        draggable
        onDragStart={dragStart}
        onDragEnd={dragEnd}
        onDragOver={dragOver}
        onDragLeave={dragLeave}
        onDrop={drop}
        onBlur={() => onFocusOut(node)}
        onDoubleClick={() => onDoubleClick(node)}
        onClick={() => {
          handleSelectItem(node);
          setSelected(node.id);
        }}
        className={`
  ${styles.treeNode}
  ${selectedId === node.id ? styles.selected : ""}
  ${dropPosition === "inside" ? styles.dropInside : ""}
  ${dropPosition === "before" ? styles.dropBefore : ""}
  ${dropPosition === "after" ? styles.dropAfter : ""}
`}
      >
        {node.children.length > 0 ? (
          <span onClick={() => toggle(node.id)} className={styles.expandIcon}>
            {expanded[node.id] ? "▼" : "▶"}
          </span>
        ) : (
          <span className={styles.spacer} />
        )}

        <span
          className={`${styles.icon} ${
            node.isDirectory
              ? expanded[node.id]
                ? styles.folderOpenIcon
                : styles.folderIcon
              : styles.fileIcon
          }`}
        />
        <span>{node.name}</span>
      </div>

      {expanded[node.id] &&
        node.children.map((child) => (
          <TreeNode
            key={child.id}
            node={child}
            expanded={expanded}
            toggle={toggle}
            onDrop={onDrop}
            onReorder={onReorder}
            selectedId={selectedId}
            setSelected={setSelected}
            handleSelectItem={handleSelectItem}
            onDoubleClick={onDoubleClick}
          />
        ))}
    </div>
  );
};

export default TreeNode;
